import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const WeatherRainyIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M21.06 12.3C21.06 14.4 19.38 16.02 17.18 16.02H8.86C6.76 16.02 5.28 14.7 5.28 12.84C5.28 12.6 5.3 12.38 5.36 12.16C4.16 11.54 3.32 10.28 3.32 8.84C3.32 6.8 5 5.1 7.06 5.1C8.18 5.1 9.2 5.6 9.88 6.38C10.66 5.9 11.6 5.64 12.62 5.64C14.54 5.64 16.38 6.76 17.34 8.74C19.68 8.8 21.06 10.38 21.06 12.3ZM5.06 8.84C5.06 9.64 5.56 10.34 6.26 10.66C6.6 10.34 7.04 10.12 7.52 10C7.64 9.06 8.02 8.22 8.56 7.54C8.18 7.12 7.64 6.84 7.06 6.84C5.98 6.84 5.06 7.76 5.06 8.84ZM7.26 12.7C7.26 13.7 8.04 14.32 9.2 14.32H16.9C18.2 14.32 19.16 13.42 19.16 12.22C19.16 10.98 18.18 10.08 16.02 10.28C15.5 8.44 14.22 7.36 12.6 7.36C10.84 7.36 9.32 8.54 9.16 11.08C7.98 11.1 7.26 11.76 7.26 12.7ZM16.6 18.28L14.16 20.68L13.02 19.54L15.44 17.12L16.6 18.28ZM12.86 18.28L10.42 20.68L9.28 19.54L11.7 17.12L12.86 18.28Z" />
    </SvgIcon>
  );
});
